export default {
  vertical: Boolean,
  gap: {
    type: Number,
    default: 1,
    validator: function (value) {
      return value >= 0
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Group/_props.js